import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000
});

// Attach JWT token for moderator calls
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('mdz_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto logout on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('mdz_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const submitResponse = (text) =>
  api.post('/responses/submit', { text });

export const getPublishedResponses = () =>
  api.get('/responses/published');

export const getAllResponses = () =>
  api.get('/responses/all');

export const updateResponseStatus = (id, status) =>
  api.patch(`/responses/${id}/status`, { status });

export const login = (username, password) =>
  api.post('/auth/login', { username, password });

export default api;
